{
  "categories": {
    "data": {
      "deviceDescription": "IoT Gerät",
      "deviceEnum": "IoT_Device",
      "deviceId": 9
    },
    "home": {
      "deviceDescription": "WLAN Home Router",
      "deviceEnum": "Router",
      "deviceId": 4
    },
    "mobile": {
      "deviceDescription": "Smartphone",
      "deviceEnum": "Smartphone",
      "deviceId": 1
    }
  },
  "products": {
    "131101": {
      "category": "data",
      "tariffType": "dataTariff",
      "defaultAliasKey": "defaultNames.dataPlan04",
      "download": 0.4,
      "upload": 0.2,
      "fullspeed": false,
      "internationalCallsSec": "notIncluded"
    },
    "131102": {
      "category": "data",
      "tariffType": "dataTariff",
      "defaultAliasKey": "defaultNames.dataPlan1",
      "download": 1.0,
      "upload": 0.5,
      "fullspeed": false,
      "internationalCallsSec": "notIncluded"
    },
    "131103": {
      "category": "data",
      "tariffType": "dataTariff",
      "defaultAliasKey": "defaultNames.dataPlan10",
      "download": 10,
      "upload": 5,
      "fullspeed": false,
      "internationalCallsSec": "notIncluded"
    },
    "131104": {
      "category": "data",
      "tariffType": "dataTariff",
      "defaultAliasKey": "defaultNames.dataPlan50",
      "download": 50,
      "upload": 25,
      "fullspeed": false,
      "internationalCallsSec": "notIncluded"
    },
    "131105": {
      "category": "data",
      "tariffType": "dataTariff",
      "defaultAliasKey": "defaultNames.dataPlan300",
      "download": 300,
      "upload": 150,
      "fullspeed": false,
      "internationalCallsSec": "notIncluded"
    },
    "131111": {
      "category": "data",
      "tariffType": "dataTariff",
      "defaultAliasKey": "defaultNames.dataPlan04",
      "download": 0.4,
      "upload": 0.2,
      "fullspeed": false,
      "internationalCallsSec": "notIncluded"
    },
    "131112": {
      "category": "data",
      "tariffType": "dataTariff",
      "defaultAliasKey": "defaultNames.dataPlan1",
      "download": 1.0,
      "upload": 0.5,
      "fullspeed": false,
      "internationalCallsSec": "notIncluded"
    },
    "131113": {
      "category": "data",
      "tariffType": "dataTariff",
      "defaultAliasKey": "defaultNames.dataPlan10",
      "download": 10,
      "upload": 5,
      "fullspeed": false,
      "internationalCallsSec": "notIncluded"
    },
    "131114": {
      "category": "data",
      "tariffType": "dataTariff",
      "defaultAliasKey": "defaultNames.dataPlan50",
      "download": 50,
      "upload": 25,
      "fullspeed": false,
      "internationalCallsSec": "notIncluded"
    },
    "131115": {
      "category": "data",
      "tariffType": "dataTariff",
      "defaultAliasKey": "defaultNames.dataPlan300",
      "download": 300,
      "upload": 150,
      "fullspeed": false,
      "internationalCallsSec": "notIncluded"
    },
    "131121": {
      "category": "data",
      "tariffType": "dataTariff",
      "defaultAliasKey": "defaultNames.dataPlan2000",
      "download": 2000,
      "upload": 300,
      "fullspeed": false,
      "internationalCallsSec": "notIncluded"
    },
    "131122": {
      "category": "data",
      "tariffType": "dataTariff",
      "defaultAliasKey": "defaultNames.dataPlan2000",
      "download": 2000,
      "upload": 300,
      "fullspeed": false,
      "internationalCallsSec": "notIncluded"
    },
    "131601": {
      "category": "mobile",
      "tariffType": "flatMobileTwo",
      "defaultAliasKey": "defaultNames.flatMobileTwo",
      "download": 2000,
      "upload": 300,
      "fullspeed": true,
      "internationalCallsSec": "6000",
      "roamingDataGb": 20,
      "roamingProduct": "mvno.1084"
    },
    "131602": {
      "category": "mobile",
      "tariffType": "flatMobileOne",
      "defaultAliasKey": "defaultNames.flatMobileOne",
      "download": 2000,
      "upload": 300,
      "fullspeed": true,
      "internationalCallsSec": "1800",
      "roamingDataGb": 3,
      "roamingProduct": "mvno.1082"
    },
    "131603": {
      "category": "mobile",
      "tariffType": "flatMobileThree",
      "defaultAliasKey": "defaultNames.flatMobileThree",
      "download": 2000,
      "upload": 300,
      "fullspeed": true,
      "internationalCallsSec": "unlimited",
      "roamingDataGb": 50,
      "roamingProduct": "mvno.1088"
    },
    "131611": {
      "category": "mobile",
      "tariffType": "flatMobileTwo",
      "defaultAliasKey": "defaultNames.flatMobileTwo",
      "download": 2000,
      "upload": 300,
      "fullspeed": true,
      "internationalCallsSec": "72000",
      "roamingDataGb": 20,
      "roamingProduct": "mvno.1084"
    },
    "131612": {
      "category": "mobile",
      "tariffType": "flatMobileOne",
      "defaultAliasKey": "defaultNames.flatMobileOne",
      "download": 2000,
      "upload": 300,
      "fullspeed": true,
      "internationalCallsSec": "21600",
      "roamingDataGb": 3,
      "roamingProduct": "mvno.1082"
    },
    "131613": {
      "category": "mobile",
      "tariffType": "flatMobileThree",
      "defaultAliasKey": "defaultNames.flatMobileThree",
      "download": 2000,
      "upload": 300,
      "fullspeed": true,
      "internationalCallsSec": "unlimited",
      "roamingDataGb": 50,
      "roamingProduct": "mvno.1088"
    },
    "131801": {
      "category": "home",
      "tariffType": "flatHome4G",
      "defaultAliasKey": "defaultNames.homeInternet4G",
      "download": 50,
      "upload": 25,
      "fullspeed": false,
      "internationalCallsSec": "notIncluded"
    },
    "131811": {
      "category": "home",
      "tariffType": "flatHome5G",
      "defaultAliasKey": "defaultNames.homeInternet5G",
      "download": 300,
      "upload": 150,
      "fullspeed": false,
      "internationalCallsSec": "notIncluded"
    }
  }
}
